// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aa-sentiment-popup .header-sentiment-chart p {
  color: var(--AA-gloabl-text-color);
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
}
.aa-sentiment-popup .header-sentiment-chart svg path {
  stroke: var(--AA-gloabl-text-color);
}
.aa-sentiment-popup .header-sentiment-chart .close-sentiment-chart {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
}
.aa-sentiment-popup .header-sentiment-chart .close-sentiment-chart svg path {
  stroke: var(--AA-gloabl-text-color);
}`, "",{"version":3,"sources":["webpack://./src/components/common/templatemanager/tabs/sentimentScore/sentimentScore.scss"],"names":[],"mappings":"AAIO;EACK,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAHZ;AAMY;EACI,mCAAA;AAJhB;AAOO;EACC,uBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;AALR;AAOgB;EACI,mCAAA;AALpB","sourcesContent":["\n\n.aa-sentiment-popup{\n    .header-sentiment-chart{\n       p{\n            color: var(--AA-gloabl-text-color);\n            font-size: 12px;\n            font-weight: 400;\n            line-height: 20px;\n       }\n       svg{\n            path{\n                stroke: var(--AA-gloabl-text-color);\n            }\n       }\n       .close-sentiment-chart{\n        background: transparent;\n        border: none;\n        cursor: pointer;\n        padding: 0;\n            svg{\n                path{\n                    stroke: var(--AA-gloabl-text-color);\n                }\n            }\n       }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
